import { styled } from '@mui/material';

import type { WrapperProps } from './Wrapper.types';

export function Wrapper({ children, ...props }: WrapperProps) {
  return (
    <StyledAccountListContainer {...props}>
      {children}
    </StyledAccountListContainer>
  );
}

export const StyledAccountListContainer = styled('fieldset')(({ theme }) => ({
  borderWidth: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  padding: 0,
}));
